import React from 'react';
import PropTypes from 'prop-types';
import { bindPopover } from 'material-ui-popup-state/hooks';

import { useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Popover from '@material-ui/core/Popover';
import Divider from '@material-ui/core/Divider';

import { useStyles } from './styles';
import Button from '../../Button';
import { useTranslation } from 'react-i18next';

const MyDesignsPopover = ({ popupState, handleLogIn }) => {
	const { t } = useTranslation();
	const classes = useStyles();
	const theme = useTheme();

	return (
		<Popover
			{...bindPopover(popupState)}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'right'
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'right'
			}}
			PaperProps={{
				style: {
					boxShadow: theme.shadows[2]
				}
			}}>
			<div className={classes.content}>
				<Typography variant="subtitle1">{t('components.navbar.myDesigns.popover.subtitle1')}</Typography>

				<Typography variant="body1" color="textSecondary" className={classes.message}>
					{t('components.navbar.myDesigns.popover.subtitle2')}
				</Typography>
			</div>

			<Divider />

			<Grid item container justify="flex-end">
				<Grid item className={classes.button}>
					<Button bold onClick={handleLogIn}>
						{t('components.navbar.myDesigns.button')}
					</Button>
				</Grid>
			</Grid>
		</Popover>
	);
};

MyDesignsPopover.propTypes = {
	popupState: PropTypes.object.isRequired,
	handleLogIn: PropTypes.func.isRequired
};

export default MyDesignsPopover;
